// Who A Heart For Care is to the outside world: the address of this app and
// the mailboxes people are told to write to.
//
// Before 2026-10-24 the app's address was typed out in 21 files and the
// support and CRM mailboxes in a dozen more. This is the one copy, for both
// runtimes: edge functions import it through _shared/org.ts, which adds the
// APP_URL override for another deployment.
//
// Two organisation facts deliberately live elsewhere, each with its own owner:
//   - billing identity (NPI, Medicaid ID, legal name): company_info, edited at
//     Settings → General Info, read through lib/edi/billingIdentity.js
//   - Drive roots: lib/driveRoots.js in the app, _shared/drive.ts in functions
//
// Runtime-neutral: no imports, no browser or Deno globals.

export const ORG_NAME = 'A Heart For Care';

/** Where this app lives. Links in emails, texts and copied URLs start here. */
export const APP_URL = 'https://crm.aheartforcare.com';
export const APP_HOST = APP_URL.replace(/^https?:\/\//, '');

/** The public website. */
export const WEBSITE_URL = 'https://www.aheartforcare.com';
export const WEBSITE_HOST = WEBSITE_URL.replace(/^https?:\/\//, '');

/** Families, referrers and applicants write here. */
export const SUPPORT_EMAIL = 'support@aheartforcare.com';
/** The office's working inbox: internal notices, team copies, staff questions. */
export const CRM_EMAIL = 'crm@aheartforcare.com';
export const NOREPLY_EMAIL = 'noreply@aheartforcare.com';
/** The owner's inbox: blind copies of signed staff paperwork, run notices. */
export const OWNER_EMAIL = 'bisi@aheartforcare.com';

/** A link into the app, e.g. appLink('/tasks'). */
export const appLink = (path = '') => `${APP_URL}${path}`;
